import fetchCustomerInfo from './fetchCustomerInfo';

export default fetchCustomerInfo;
